import React from 'react'
import SharedCoachInfo from './SharedCoachInfo'

const PlanCoachInfo = ({ plan }) => {
  return (
    <>
      <div className='plan-sidebar-title-container'>
        <h4 className='plan-sidebar-title'>
          <span className='mobile'>
            {`Instructor${plan?.coaches?.length > 1 ? 's' : ''}`}
          </span>
          <span className='desktop'>Instructor</span>{' '}
          <span className='profile'>
            {`Profile${plan?.coaches?.length > 1 ? 's' : ''}`}
          </span>
        </h4>
      </div>
      {plan?.coaches?.map((c) => (
        <SharedCoachInfo key={c?.slug} coach={c} />
      ))}
    </>
  )
}

export default PlanCoachInfo
